/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-30 14:15:39
 * @FilePath: \hlweb2.0\src\pages\Solution\Asset\ServiceValue\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
function Challenge() {
  const { t } = useTranslation();
  const challengeInfo = t("solution_asset.asset4", {
    returnObjects: true,
  });
  return (
    <div className="challenge_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{challengeInfo.title}</div>
          <span>{challengeInfo.detail}</span>
        </div>
      </div>
      <div className="challenge_con">
        {challengeInfo.contentList.map((item0, index0) => {
          return (
            <div className="challenge_li" key={index0}>
              <div className="challenge_li_til">{item0.til}</div>
              <div className="challenge_li_con">
                {item0.list.map((item, index) => {
                  return <div key={index}>{item}</div>;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Challenge;
